import type { HomeLatestViewpoint } from "../../SpaceType";
import { formatPublishTime } from "../../spacePageUtils";

/** 观点最新卡片（带权限校验） */
export function SpaceHomeViewpointPreview(props: {
  viewpoint: HomeLatestViewpoint;
}): JSX.Element {
  const { viewpoint } = props;
  const accessible = viewpoint.contentAccessible;

  return (
    <section className="space-home-feed__section" aria-label="最新观点">
      <p className="space-home-feed__section-hint">最新观点</p>
      <div
        className={
          accessible
            ? "space-home-feed__hcard space-home-feed__hcard--viewpoint"
            : "space-home-feed__hcard space-home-feed__hcard--viewpoint space-home-feed__hcard--viewpoint-locked"
        }
      >
        {viewpoint.imageUrl && viewpoint.imageUrl.trim() !== "" ? (
          <div className="space-home-feed__hcard-thumb">
            <img src={viewpoint.imageUrl} alt="" width={200} height={112} />
          </div>
        ) : null}
        <div className="space-home-feed__hcard-body">
          {accessible ? (
            <p className="space-home-feed__hcard-text">{viewpoint.content}</p>
          ) : (
            <p className="space-home-feed__hcard-text space-home-feed__hcard-text--locked">
              订阅观点产品后可查看全文
            </p>
          )}
          {viewpoint.publishTime && viewpoint.publishTime.trim() !== "" ? (
            <p className="space-home-feed__hcard-time">
              {formatPublishTime(viewpoint.publishTime)}
            </p>
          ) : null}
        </div>
      </div>
    </section>
  );
}
